export function iconSportCssClass(sportId, iconClass) {
	let cssClass = `icoSport${sportId}`;
	if (iconClass?.length > 0) {
		cssClass += ` cms-setted-sport-${iconClass}`;
	}
	return cssClass;
}
